import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import PersonIcon from '@mui/icons-material/Person';

import {
  selectTrafficOffensesPinnedFilters,
  togglePinnedFiltersState,
} from '@store';
import { useHasFilters } from 'hooks/common';

export const useTrafficOffensesFilterConfig = ({ assignees }) => {
  const router = useRouter();
  const dispatch = useDispatch();
  const pinnedFilters = useSelector(selectTrafficOffensesPinnedFilters);

  const filterCategories = useMemo(
    () => [
      {
        id: 'assignee',
        label: 'Assignee',
        icon: PersonIcon,
        options: assignees || [],
      },
    ],
    [assignees]
  );

  const currentFilters = useMemo(() => {
    return {
      assignee: router.query.assignee,
    };
  }, [router.query]);

  const handlePinnedFilterSelect = (pinnedFilter) => {
    dispatch(
      togglePinnedFiltersState({ board: 'trafficOffenses', pinnedFilter })
    );
  };

  const { hasFilters } = useHasFilters({
    pinnedFilters,
  });

  return {
    filterCategories,
    currentFilters,
    handlePinnedFilterSelect,
    pinnedFilters,
    supportPinnedFilters: true,
    hasFilters,
  };
};

export default useTrafficOffensesFilterConfig;
